import React from "react";

export default function FilterChip({ active, onClick, children, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={[
        "px-5 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-all border active:scale-95",
        active
          ? "bg-sky-500 text-white border-sky-500 shadow-[0_8px_20px_-8px_rgba(14,165,233,0.5)]"
          : "bg-white text-slate-700 border-slate-200 hover:border-sky-300 hover:text-sky-600",
      ].join(" ")}
    >
      {children}
    </button>
  );
}
